<template>
  <div class="user">

    <header class="demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600">
      <div class="mdl-layout__header-row">

        <span class="mdl-layout-title">User</span>
        <div class="mdl-layout-spacer"></div>

      </div>
    </header>

    <div class="loading-holder" v-if="!user">
      <h3>Loading Data...</h3>
      <div class="mdl-progress mdl-js-progress mdl-progress__indeterminate"></div>
      <h4>Please wait!</h4>
    </div>

    <div class="user-card mdl-card mdl-shadow--2dp" v-if="user">
      <div class="mdl-card__title mdl-color--primary">
        <h2 class="mdl-card__title-text">{{ user.display }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-grid" v-bind:class="{ blurred: state == 'saving' }">

        <div class="mdl-cell mdl-cell--9-col mdl-cell--12-col-phone">
          <p>User Id: {{ user.id }}</p>
          <p>Display name: "{{ user.display }}"</p>
          <div class="props">
            <div v-for="(prop, index) in userDataProps" class="prop">
              <div class="field mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                <input class="mdl-textfield__input" type="text" :id="'userData_key_'+prop.key" v-model="prop.key"
                       v-bind:required="required" :ref="'userData_key_'+prop.key">
                <label class="mdl-textfield__label" :for="'userData_key_'+prop.key">Field</label>
              </div>
              <div v-if="propType(prop) == 'text'" class="field mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                <input class="mdl-textfield__input" type="text" :id="'userData_value_'+prop.key" v-model="prop.value"
                       v-bind:required="required" :ref="'userData_value_'+prop.key">
                <label class="mdl-textfield__label" :for="'userData_value_'+prop.key">{{ prop.key }}</label>
              </div>
              <PhoneInput v-if="propType(prop) == 'phone'" class="phoneNumber field"
                          :value.sync="prop.value" :required="required" :invalid="false"
                          :label="prop.key"></PhoneInput>
              <CountryInput v-if="propType(prop) == 'country'" class="country field"
                            :value.sync="prop.value" :required="required" :invalid="false"
                            :label="prop.key"></CountryInput>
              <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent"
                      @click="deleteProp(index)"><i class="material-icons">delete_forever</i></button>
              <br>
            </div>
            <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent"
                    @click="addProp"><i class="material-icons">add</i></button>
          </div>
        </div>

        <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
          <h6>Roles:</h6>
          <div class="role-switch" v-for="role in possibleRoles" v-on:click="toggleRole(role)">
            <span>
              <i v-if="roles.indexOf(role) != -1" class="material-icons">check_box</i>
              <i v-if="roles.indexOf(role) == -1" class="material-icons">check_box_outline_blank</i>
            </span>
            <span>{{ role }}</span>
          </div>
        </div>

      </div>
      <div class="mdl-card__actions mdl-card--border right-actions" v-bind:class="{ blurred: state == 'saving' }">
        <button v-on:click="save" :disabled="!userChanged" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          Save
        </button>
        <button v-on:click="openRemoveDialog" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          Remove
        </button>
      </div>
      <div class="mdl-card__title mdl-color--primary">
        <h2 class="mdl-card__title-text">Authentication methods:</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand mdl-grid" v-bind:class="{ blurred: state == 'saving' }">

        <div v-for="loginMethod in user.loginMethods" class="mdl-cell-6-col">
          <div class="login-method mdl-card mdl-shadow--2dp">
            <div class="mdl-card__title mdl-color--primary">
              {{ loginMethod.type }}
            </div>
            <div class="mdl-card__supporting-text">
              <p>{{ loginMethod.id }}</p>
            </div>
            <div class="mdl-card__actions mdl-card--border">
              <a v-if="loginMethod.type == 'emailPassword'"
                 v-on:click="openRemoveEmailDialog(loginMethod)"
                 class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
                Remove
              </a>
              <a v-if="loginMethod.type == 'emailPassword'"
                 v-on:click="openChangeEmailPasswordDialog(loginMethod)"
                 class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
                Change password
              </a>
            </div>
          </div>

        </div>

        <div class="mdl-cell-6-col">
          <div class="add-login-method" v-on:click="openAddEmailPasswordDialog">
            <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--colored">
              <i class="material-icons">add</i>
            </button>
            <span>Add Email/password</span>
          </div>
        </div>

      </div>
    </div>

    <div v-if="confirmDialog" class="dialog-holder">
      <div class="dialog mdl-card mdl-shadow--4dp">
        <div class="mdl-card__title mdl-color--accent" >
          <h2 class="mdl-card__title-text">{{ confirmDialog.title }}</h2>
          <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent"
                  @click="closeDialog"><i class="material-icons">close</i></button>
        </div>
        <div class="mdl-card__supporting-text mdl-card--expand">
          {{ confirmDialog.text }}
        </div>
        <div class="mdl-card__actions mdl-card--border" v-bind:class="{ blurred: state == 'saving' }">
          <a v-on:click="closeDialog" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            Cancel
          </a>
          <a v-on:click="confirmDialog.action" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            {{ confirmDialog.actionName || 'Ok' }}
          </a>
        </div>
      </div>
    </div>

    <div v-if="changeEmailPasswordDialog" class="dialog-holder" :class="{blurred: this.state=='saving'}">
      <div class="dialog mdl-card mdl-shadow--4dp">
        <div class="mdl-card__title mdl-color--accent" >
          <h2 class="mdl-card__title-text">Change password</h2>
          <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent"
                  @click="() => changeEmailPasswordDialog = false"><i class="material-icons">close</i></button>
        </div>
        <div class="mdl-card__supporting-text mdl-card--expand">

          <div class="serverError" v-if="error">{{ error }}</div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="newPassword1"
                   v-model="newPassword1" ref="newPassword1">
            <label class="mdl-textfield__label" for="newPassword2">New password</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="newPassword2"
                   v-model="newPassword2" ref="newPassword2">
            <label class="mdl-textfield__label" for="newPassword2">Retype password</label>
            <span v-if="notMatch" class="mdl-textfield__error">Passwords does not match</span>
          </div>

        </div>
        <div class="mdl-card__actions mdl-card--border right-actions" v-bind:class="{ blurred: state == 'saving' }">
          <a v-on:click="() => changeEmailPasswordDialog = false" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            Cancel
          </a>
          <a v-on:click="changeEmailPassword" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            Change password
          </a>
        </div>
      </div>
    </div>

    <div v-if="addEmailPasswordDialog" class="dialog-holder" :class="{ blurred: this.state == 'saving' }">
      <div class="dialog mdl-card mdl-shadow--4dp">
        <div class="mdl-card__title mdl-color--accent" >
          <h2 class="mdl-card__title-text">Change password</h2>
          <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent"
                  @click="() => addEmailPasswordDialog = false"><i class="material-icons">close</i></button>
        </div>
        <div class="mdl-card__supporting-text mdl-card--expand">

          <div class="serverError" v-if="error">{{ error }}</div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label">
            <input class="mdl-textfield__input" type="email" id="email"
                   v-model="newEmail">
            <label class="mdl-textfield__label" for="email">New email</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="newPassword1"
                   v-model="newPassword1" ref="newPassword1">
            <label class="mdl-textfield__label" for="newPassword2">New password</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="newPassword2"
                   v-model="newPassword2" ref="newPassword2">
            <label class="mdl-textfield__label" for="newPassword2">Retype password</label>
            <span v-if="notMatch" class="mdl-textfield__error">Passwords does not match</span>
          </div>

        </div>
        <div class="mdl-card__actions mdl-card--border" v-bind:class="{ blurred: state == 'saving' }">
          <a v-on:click="() => addEmailPasswordDialog = false" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            Cancel
          </a>
          <a v-on:click="addEmailPassword" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            Add email/password
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import api from "api"
  import config from "../config"

  import PhoneInput from "./utils/PhoneInput"
  import CountryInput from "./utils/CountryInput"

  export default {
    name: 'user',
    components: {
      PhoneInput, CountryInput
    },
    data () {
      return {
        user: null,
        possibleRoles: config.possibleRoles,
        displayName: '',
        roles: [],
        state: 'loading',
        confirmDialog: null,
        changeEmailPasswordDialog: false,
        newPasswordEmail: '',
        newPassword1 : '',
        newPassword2 : '',
        addEmailPasswordDialog: false,
        newEmail: '',
        userDataProps: [],
        notMatch: false,
        required: false,
        dialogError: null
      }
    },
    computed: {
      rolesChanged() {
        console.log("ROLES CHANGED?", this.roles, this.user.roles)
        if(this.roles.length != this.user.roles.length) return true
        for(let role of this.roles) if(this.user.roles.indexOf(role) == -1) return true
        for(let role of this.user.roles) if(this.roles.indexOf(role) == -1) return true
        return false
      },
      editedUserData() {
        let obj = {}
        for(let prop of this.userDataProps) {
          if(prop.key.length>0) obj[prop.key] = prop.value
        }
        return obj
      },
      userDataChanged() {
        return JSON.stringify(this.user.userData) != JSON.stringify(this.editedUserData)
      },
      userChanged() {
        return this.rolesChanged || this.userDataChanged
      }
    },
    watch: {
      '$route' (to, from) {
        if(this.observable) this.observable.unbindProperty(this, "user")
        this.observable = api.observable(['userAdmin', 'user', to.params.userId])
        this.observable.bindProperty(this, "user")
      },
      user(v) {
        if(v != null) this.state = 'loaded'
        this.displayName = this.user.display
        this.userDataProps = []
        for(let key in this.user.userData) {
          this.userDataProps.push({
            key: key,
            value: this.user.userData[key]
          })
        }
        this.roles = this.user.roles.slice() || []
      }
    },
    methods: {
      propType(prop) {
        if(prop.key == 'phoneNumber') return "phone"
        if(prop.key == 'country') return "country"
        return 'text'
      },
      toggleRole(role) {
        let index = this.roles.indexOf(role)
        if(index != -1) this.roles.splice(index, 1)
        if(index == -1) this.roles.push(role)
      },
      save() {
        this.state = 'saving'
        let savePromises = []
        if(this.rolesChanged) savePromises.push(
          api.request(['userAdmin', 'updateRoles'], this.user.id, this.roles)
        )
        if(this.userDataChanged) savePromises.push(
          api.request(['userAdmin', 'updateUserData'], this.user.id, this.editedUserData)
        )
        Promise.all(savePromises).then(
          results => {
            this.state = 'saved'
          }
        ).catch(
          error => this.state = 'broken'
        )
      },
      closeDialog() {
        this.confirmDialog = null
      },
      openRemoveDialog() {
        this.confirmDialog = {
          title: "Remove User?",
          text: "Do you really want to remove user " + this.user.display+"?",
          action: () => {
            this.state = 'saving'
            api.request(['userAdmin', 'removeUser'], this.user.id).then(
              result => {
                this.$router.replace({ name:'users' })
              }
            )
          }
        }
      },
      openChangeEmailPasswordDialog(loginMethod) {
        this.changeEmailPasswordDialog = true
        this.newPassword1 = ''
        this.newPassword2 = ''
        this.newPasswordEmail = loginMethod.id
        this.required = false
        this.notMatch = false
      },
      changeEmailPassword() {
        if(this.newPassword1.trim() == '' || this.newPassword2.trim() == '') {
          this.required = true
          if(this.newPassword2.trim()=='') {
            this.$refs.newPassword2.parentElement.setAttribute('class',
              this.$refs.newPassword2.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.newPassword2.focus()
          }
          if(this.newPassword1.trim()=='') {
            this.$refs.newPassword1.parentElement.setAttribute('class',
              this.$refs.newPassword1.parentElement.getAttribute('class') + ' is-invalid')
            this.$refs.newPassword1.focus()
          }
          return
        }

        this.notMatch = (this.newPassword1 != this.newPassword2)
        if(this.notMatch) {
          this.$refs.newPassword2.parentElement.setAttribute('class',
            this.$refs.newPassword2.parentElement.getAttribute('class')+' is-invalid')
          this.$refs.newPassword2.focus()
          return;
        }

        this.changeEmailPasswordDialog = false;
        this.state = 'saving'
        api.request(['userAdmin', 'updateEmailPassword'], this.newPasswordEmail, this.newPassword1).then(
          result => {
            this.state = 'loaded'
          }
        ).catch(
          error => {
            this.dialogError = error
            this.state = 'loaded'
          }
        )
      },
      openRemoveEmailDialog(loginMethod) {
        this.confirmDialog = {
          title: "Remove login method?",
          text: "Do you really want to remove user " + this.user.display
               +" email "+loginMethod.id+" ?",
          action: () => {
            this.state = 'saving'
            api.request(['userAdmin', 'removeEmailFromUser'], this.user.id, loginMethod.id).then(
              result => {
                this.state = 'loaded'
                this.closeDialog()
              }
            )
          }
        }
      },
      openAddEmailPasswordDialog() {
        this.addEmailPasswordDialog = true
        this.newPassword1 = ''
        this.newPassword2 = ''
        this.newEmail = ''
        this.required = false
        this.notMatch = false
      },
      addEmailPassword() {
        if(this.newPassword1.trim() == '' || this.newPassword2.trim() == '') {
          this.required = true
          if(this.newPassword2.trim()=='') {
            this.$refs.newPassword2.parentElement.setAttribute('class',
              this.$refs.newPassword2.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.newPassword2.focus()
          }
          if(this.newPassword1.trim()=='') {
            this.$refs.newPassword1.parentElement.setAttribute('class',
              this.$refs.newPassword1.parentElement.getAttribute('class') + ' is-invalid')
            this.$refs.newPassword1.focus()
          }
          return
        }

        this.notMatch = (this.newPassword1 != this.newPassword2)
        if(this.notMatch) {
          this.$refs.newPassword2.parentElement.setAttribute('class',
            this.$refs.newPassword2.parentElement.getAttribute('class')+' is-invalid')
          this.$refs.newPassword2.focus()
          return;
        }

        this.state = 'saving'
        api.request(['userAdmin', 'addEmailToUser'], this.user.id, this.newEmail, this.newPassword1).then(
          result => {
            this.state = 'loaded'
            this.addEmailPasswordDialog = false
          }
        ).catch(
          error => {
            this.dialogError = error
            this.state = 'loaded'
          }
        )
      },
      deleteProp(index) {
        this.userDataProps.splice(index, 1)
      },
      addProp() {
        this.userDataProps.push({
          key: '',
          value: ''
        })
      }

    },
    created() {
    },
    beforeDestroy() {
      if(this.observable) this.observable.unbindProperty(this, "user")
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
      this.observable = api.observable(['userAdmin', 'user', this.$route.params.userId])
      this.observable.bindProperty(this, "user")
    }
  }

</script>

<style scoped>

  .user-card {
    margin: 23px auto auto;
    min-height: 70vh;
    min-width: 91%;
  }

  .loading-holder {
    position: absolute;
    right: 0em;
    left: 0em;
    width: auto;
    top: 0em;
    bottom: 0em;
    height: auto;
    text-align: center;
  }
  .loading-holder .mdl-progress {
    margin-left: auto;
    margin-right: auto;
  }

  .role-switch i {
    vertical-align: middle;
  }

  h6 {
    margin: 0;
  }

  .blurred {
    filter: blur(2px);
  }

  .dialog-holder {
    z-index: 10;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
  }

  .dialog-holder .mdl-card__title button {
    display: block;
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-right: 0px;
    float: right;
  }
  .dialog-holder .mdl-card__title button > i {
    font-size: 20px;
  }
  .dialog {
    min-width: 30%;
    margin-left: auto;
    margin-right: auto;
  }
  .dialog .mdl-card__actions a {
    float: right;
  }

  .login-method {
    min-height: 70px;
  }

  .login-method .mdl-card__title {
    padding: 6px 10px;
  }

  .add-login-method {
    border: dashed 4px silver;
    margin: 10px;
    padding: 10px;
    font-size: 1.23em;
    cursor: pointer;
  }

  .right-actions > a, .right-actions > button {
    float: right;
  }

  .props .mdl-textfield {
    margin-right: 1em;
    vertical-align: baseline;
  }

  .props button {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 4px;
  }
  .props > button > i {
    font-size: 20px;
  }

  .field {
    max-width: 250px;
    margin-right: 1em;
  }

</style>



// WEBPACK FOOTER //
// User.vue?440f3867